import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
  Grid,
  Box
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Fade } from "react-reveal";

const FAQSection = () => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const faqs = [
    {
      question: "What Are Features Available In Our App?",
      answer:
        "Our app offers features like investment tracking, personalized financial advice, and real-time financial insights.",
    },
    {
      question: "What Are The Advantage Of Our App?",
      answer:
        "This tool enables you to track investments and offer personalized advice efficiently.",
    },
    {
      question: "Why Are App Is Best For Personal Financial Management?",
      answer:
        "Our app is the best for personal financial management by offering seamless tracking, analysis, and expert advice in one platform.",
    },
    {
      question: "How Secure Is Our App?",
      answer:
        "Our app ensures top-notch security with mTLS authentication and secure token generation to protect user data and transactions.",
    },
    {
      question: "What Are Unique Feature In Our App?",
      answer:
        "Personalized financial advice, real-time analytics, mTLS security, and easy client management are some of the distinctive features that make our app stand out.",
    },
    {
      question: "Why Customer Should Subscribe Our App?",
      answer:
        "For safe, individualized financial insights, effective management tools, and real-time investment tracking, customers should download our app.",
    },
  ];

  return (
    <Box sx={{ py: 5 }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", maxWidth: 800, mx: "auto", mb: 5, paddingTop: "100px" }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: {
                xs: "1.5rem", 
                sm: "2rem",   
                md: "2.5rem"  
              },
              fontWeight: "bold",
              mb: 3,
              color: "#FFF"
            }}
          >
            Frequently Asked Questions
          </Typography>
          <Typography variant="body1" sx={{ color: "#FFF" }}>
            Our app provides a comprehensive FAQ section to address common queries and guide financial consultants in using its features effectively.
          </Typography>
        </Box>

        <Grid container spacing={5} justifyContent="center">
          <Grid item xs={12} md={8}>
            <Box sx={{ borderRadius: 2, p: 2 }}>
              {faqs.map((faq, index) => (
                <Fade bottom delay={index * 150} key={index}>
                  <Accordion
                    expanded={expanded === index}
                    onChange={handleChange(index)}
                    sx={{ mb: 2 }} // Add some spacing between items
                  >
                    <AccordionSummary
                      expandIcon={
                        expanded === index ? (
                          <RemoveIcon sx={{ color: "#067e3e" }} />
                        ) : (
                          <AddIcon sx={{ color: "#067e3e" }} />
                        )
                      }
                      aria-controls={`panel${index}-content`}
                      id={`panel${index}-header`}
                      sx={{
                        boxShadow: 3,
                        color: "#067e3e",
                      }}
                    >
                      <Typography variant="h6">{faq.question}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>{faq.answer}</Typography>
                    </AccordionDetails>
                  </Accordion>
                </Fade>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default FAQSection;
